import * as React from 'react'
import styled from 'styled-components'
import { Box, Typography, List, ListItem } from '@mui/material'
import MuiAccordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

export default function AlzheimerSubSectionCard({data, sx}) {
    const [references, setReferences] = React.useState(null);
    const [isExanded, setIsExpanded] = React.useState(true)
    const [isRed, setIsRed] = React.useState(false);
    const [contentPadding, setContentPadding] = React.useState(0)
    React.useEffect(() => {
        if(data) {
            setReferences(data.references)
            const _isRed = data.genotype === 'E4/E4';
            setIsRed(_isRed)
            setContentPadding(_isRed ? 2 : 0)
        }
        
    }, []);
    const formatText = (text) => {
        return text?.split("ε").map((part, index) =>
          index < text.split("ε").length - 1 ? (
            <>
              {part}
              <span style={{ fontSize: "21px" }}>ε</span>
            </>
          ) : (
            part
          )
        );
    };
    return (
        <>
            <Accordion
                sx={{
                    borderRadius: 2,
                    bgcolor: 'primary.white',
                    boxShadow: '0px 2px 20px 0px #5B87EF66;',
                    overflow: 'hidden',
                    ...sx
                }}
                expanded={isExanded}
            >
                {/* Title */}
                <AccordionSummary 
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: 'background.default',
                        p: 2
                    }}
                    expandIcon={<ExpandMoreIcon 
                        sx={{
                            color: 'primary.black'
                        }}
                    />}
                    expanded={isExanded}
                    onClick={() => setIsExpanded(!isExanded)}
                >
                    <Typography variant='h2'>Alzheimer’s and Dementia </Typography>
                </AccordionSummary>
                <AccordionDetails 
                    sx={{
                        p: 2,
                        mt: 1
                    }}
                >
                    {/* GenoType Alert*/}
                    <Box
                        sx={{
                            mt: 1,
                            border: '2px solid',
                            borderColor: isRed ? 'primary.red' : 'primary.white',
                            borderRadius: '8px',
                            p: contentPadding,
                            bgcolor: isRed ? 'primary.lightRed' : 'primary.white'
                        }}
                    >
                        <Typography variant='h2'>
                            Your APOE genotype is:  {data.genotype}
                        </Typography>

                        <Typography variant='h4' sx={{
                            mt: 2,
                            fontWeight: 500
                        }}>
                            {formatText(data.genotype_description)}
                        </Typography>
                    </Box>
                    <Box sx={{p: contentPadding, pb: 0}}>
                        {/* Geno Detail row */}
                        <Box sx={{ mt: 1 }}>
                            <Typography variant='h2'>
                                More information
                            </Typography>
                            <Typography variant='h4' sx={{
                                mt: 1,
                                fontWeight: 500
                            }}>
                                {formatText(data.introduction)}
                                <br/>
                                <br/>
                                {formatText(data.sex_ancestry)}
                            </Typography>
                        </Box>
                        {references &&
                            <Box sx={{mt: 3}}>
                                <Typography variant='h2'>
                                    References
                                </Typography>
                                    <List sx={{mt: 1}}>
                                        {references.map((text, index) => (
                                            <ListItem key={index}>
                                                <Typography variant='h4' sx={{fontWeight: 500}}>{index + 1}. {formatText(text)}</Typography>
                                            </ListItem>
                                        ))}
                                    </List>
                            </Box>
                        }
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: 'none',
  
  '&:not(:last-child)': {
    borderBottom: 0,
    // marginBottom: '14px',
  },
  '&:before': {
    display: 'none',
  },
}));